// Stale Time
export const STALE_TIME_1_MINUTES = 60 * 1000; // 1 minute;
export const STALE_TIME_3_MINUTES = 60 * 1000 * 3; // 3 minutes;
export const STALE_TIME_5_MINUTES = 60 * 1000 * 5; // 5 minutes;
export const STALE_TIME_10_MINUTES = 60 * 1000 * 10; // 10 minutes;
export const STALE_TIME_60_MINUTES = 60 * 1000 * 60; // 60 minutes;

// Keys
export const ASSESSMENTS_BATCH = "assessmentsBatch";
export const ASSIGNABLE_CLINICIANS = "assignableClinicians";
export const CLINICIAN_CREDENTIALS = "clinicianCredentials";
export const CLINICIAN_STATE_LICENSE = "clinicianStateLicense";
export const CLINICIAN_CERTIFICATION = "clinicianCertification";
export const CLINICIAN_LIABILITY_INSURANCE = "clinicianLiabilityInsurance";
export const CLIENT_ASSESSMENTS = "clientAssessments";
export const CLINICIAN_WORKING_HOURS = "clinicianWorkingHours";
export const GET_V3_CLIENT_ASSESSMENTS = "getV3ClientAssessments";
export const GET_CLIENTS = "getClients";
export const GET_CLINICIAN_HOURS = "getClinicianHours";
export const GET_CLINICIAN_SESSION_UTILIZATION = "getClinicianSessionUtilization";
export const GET_GENERATED_SCHEDULES = "getGeneratedSchedules";
export const GET_INSURANCE_VOB = "getInsuranceVob";
export const GET_TEAM_MEMBERS = "getTeamMembers";
export const GET_TEAMS = "getTeams";
export const GET_TEAM_ROLES = "getTeamRoles";
export const GET_USERS = "getUsers";
export const GET_FAMILY_NAVIGATORS = "getFamilyNavigators";
export const GET_USER_BY_ID = "getUserById";
export const GET_TEAMS_CLIENT = "getTeamsClient";
export const GET_INSURANCE_PLAN = "getInsurancePlans";
export const GET_TEAM_MEMBER_INVITATION = "getTeamMemberInvitation";
export const GET_CLIENT_BY_ID = "getClientById";
export const GET_CUSTOMER_SIGNED_FORM = "GetCustomerSignedForm";
export const GET_USER_NOTIFICATION_PREFERENCES = "getUserNotificationPreferences";
export const GET_FINANCIAL_GUARANTOR = "getFinancialGuarantor";
export const GET_CUSTOMER_PHYSICIANS = "getCustomerPhysicians";
export const GET_CUSTOMER_PAST_CLINICIANS = "getCustomerPastClinicians";
export const GET_ALL_DOCUMENT_REQUESTS = "getAllDocumentRequests";
export const GET_CLINICS = "getClinics";
export const GET_CLINIC_BY_ID = "getClinicById";
export const GET_PAYOR_DATA_BY_NAME = "getPayorDataByName";
export const GET_PROVIDERS = "getProviders";
export const GET_PROVIDER_BY_ID = "getProviderById";
export const GET_RESCHEDULE_OPTIONS = "getRescheduleOptions";
export const GET_CALENDAR_SESSIONS = "getCalendarSessions";
export const GET_MATCHING_SESSIONS_BY_DATES = "getMatchingSessionsByDates";
export const INTAKE_FLOW = "intakeFlow";
export const SEARCH_PROVIDERS = "searchProviders";
export const USER_PERMISSIONS = "userPermissions";
export const LANGUAGES = "languages";
export const GET_LIST_OF_DIAGNOSIS = "getListOfDiagnosis";
export const GET_CLIENT_DIAGNOSIS = "getClientDiagnosis";
export const GET_PROCESS_STATUS = "getProcessStatus";
export const GET_PROCESS_RESULT = "getProcessResult";
export const GENERATE_PROCESS = "generateProcess";
export const GET_CHATS = "getChats";
export const GET_MESSAGES = "getMessages";
export const GET_CHAT_PREVIEWS = "getChatPreviews";
export const GET_CHAT_NOTIFICATION_STATUS = "getChatNotificationStatus";
export const GET_MESSAGES_PARTICIPANT = "getMessagesParticipant";
export const GET_FILE_PRESIGNED = "getFilePresigned";
export const GET_CLINICIAN_BASIC_INFO = "getClinicianBasicInfo";
export const GET_CLINICIAN_NEXT_APPOINTMENT = "getClinicianNextAppointment";
export const GET_CLINICIAN_CLIENTS = "getClinicianClients";
export const GET_CLINICIAN_CASELOAD_SUMMARY = "getClinicianCaseloadSummary";
export const GET_USER_TASKS = "getUserTasks";
export const GET_USER_UPCOMING_TASKS = "getUserUpcomingTasks";
export const CREATE_USER_TASK = "createUserTask";
export const UPDATE_USER_TASK = "updateUserTask";
export const GET_PROPOSED_APPOINTMENTS = "getProposedAppointments";
export const GET_APPOINTMENT_INFO = "getAppointmentInfo";
export const GET_CLIENT_VIDEO_CALLS = "getClientVideoCalls";
export const GET_USER_ANNOUNCEMENTS = "getUserAnnouncements";
export const GET_DISPLAY_FEEDBACK_DIALOG = "getDisplayFeedbackDialog";
// Goals and Targets
export const GET_LIST_OF_GOALS = "getListOfGoals";
export const GET_GOAL_BY_ID = "getGoalById";
export const GET_LIST_OF_TARGETS = "getListOfTargets";
export const GET_TARGET_BY_ID = "getTargetById";
export const GET_TARGET_SESSION_METRICS = "getTargetSessionMetrics";
export const GET_TARGET_MARKERS = "getTargetMarkers";
export const GET_GOAL_MASTERY_HISTORY = "getGoalMasteryHistory";
export const GET_TARGET_SESSIONS = "getTargetSessions";
export const GET_VIDEO_CALL_DETAILS = "getVideoCallDetails";
export const GET_DEVELOPMENTAL_HISTORY = "getDevelopmentalHistory";
export const GET_SOCIAL_HISTORY = "getSocialHistory";
export const GET_EDUCATION_HISTORY = "getEducationHistory";
export const GET_FAMILY_HISTORY = "getFamilyHistory";
export const GET_DRUG_CRIMINAL_HISTORY = "getDrugCriminalHistory";
export const GET_FAMILY_MEDICAL_HISTORY = "getFamilyMedicalHistory";
export const GET_FAMILY_MENTAL_HEALTH_HISTORY = "getFamilyMentalHealthHistory";
export const GET_SLEEP_PROFILE = "getSleepProfile";
export const GET_VARIABLES_IMPACTING_TREATMENT = "getVariablesImpactingTreatment";
export const GET_ADDITIONAL_DIAGNOSES = "getAdditionalDiagnoses";
export const GET_INTERVENTION_HISTORY = "getInterventionHistory";
export const GET_MEDICATIONS = "getMedications";
export const GET_TRAUMA_HISTORY = "getTraumaHistory";
export const GET_COLLABORATION_NOTES = "getCollaborationNotes";
export const GET_CRISIS_PLAN = "getCrisisPlan";
export const GET_DISCHARGE_PLANNING = "getDischargePlanning";
export const GET_CAREGIVER_INVOLVEMENT = "getCaregiverInvolvement";
export const GET_CLINICAL_APPROACH = "getClinicalApproach";
export const GET_OBSERVED_BEHAVIORS_STRENGTHS = "getObservedBehaviorsStrengths";
export const GET_AREAS_OF_CONCERN = "getAreasOfConcern";
export const GET_CURRENT_COMMUNICATION = "getCurrentCommunication";
export const GET_TELEHEALTH_PREREQUISITES = "getTelehealthPrerequisites";
export const GET_CLINICAL_PROGRAM_TARGETS = "getClinicalProgramTargets";
export const GET_ALL_INSURANCE_CODES = "getAllInsuranceCodes";
export const GET_CLIENT_INSURANCE_PLAN_BY_ID = "getClientInsurancePlanById";
export const GET_CLIENT_INSURANCES = "getClientInsurances";
